import React from 'react';
import {View} from 'react-native';

import ListItem from '/component/base/ListItem';
import {LoadingBox} from '/component/base/LoadingBox';
import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';
import {useTranslation} from '/provider/TranslationProvider';

import {styles} from './Loading.style';

export const Loading = () => {
  const {tt} = useTranslation('reportCardContent.eligibleForCab');

  return (
    <View>
      <View style={styles.header}>
        <Gutter>
          <Text variant="heading">
            {tt('title', 'Eligible for Client Acquisition Bonus')}
          </Text>
        </Gutter>
      </View>

      <Gutter>
        <ListItem
          style={{base: styles.listItem}}
          readonly={true}
          label={<Text>{tt('orderingEntities', 'New Ordering Entities')}</Text>}
          suffix={<LoadingBox style={styles.loadingBoxOrderingEntities} />}
        />
      </Gutter>

      <Gutter>
        <ListItem
          style={{base: styles.listItem}}
          readonly={true}
          label={<Text>{tt('fqv', 'CAB Frontline Qualifying Volume')}</Text>}
          suffix={<LoadingBox style={styles.loadingBoxFQV} />}
        />
      </Gutter>

      <Gutter>
        <ListItem
          style={{base: styles.listItem}}
          readonly={true}
          label={
            <Text>{tt('newOrderingEntities', 'CAB Ordering Entities')}</Text>
          }
          suffix={<LoadingBox style={styles.loadingBoxNewOrderingEntities} />}
        />
      </Gutter>

      <Gutter>
        <ListItem
          style={{base: styles.listItem}}
          readonly={true}
          label={
            <Text>{tt('daysRemaining', 'Days Remaining for Eligibility')}</Text>
          }
          suffix={<LoadingBox style={styles.loadingBoxDaysRemaining} />}
        />
      </Gutter>
    </View>
  );
};
